import type { APIRequestSuccess } from '~/type/APIRequestStatus'

export default function (data: APIRequestSuccess): APIRequestSuccess {
  return {
    result: data.result,
    success: data?.success,
  }
}
